module.exports = __webpack_public_path__ + "img/Macro_Sperm_Packaging_Diagram.b2b46446.png";